import StarIcon from "@/components/Icons/customIcons/Star"
import { useController } from "react-hook-form"

export const Rating = ({ name }: { name: string }) => {
  const { field } = useController({
    name,
  })

  return (
    <div className="flex items-center gap-4">
      {Array.from({ length: 5 }).map((_, index) => (
        <button
          type="button"
          key={index}
          onClick={() => field.onChange(String(index + 1))}
          className="focus:outline-none"
        >
          <StarIcon className={field.value >= index + 1 ? "fill-gold" : "fill-primary-100"} />
        </button>
      ))}
    </div>
  )
}
